module.exports = __webpack_public_path__ + "media/country_flags/fk-3591ec9e.png";